__turbopack_context__.v({
  "category": "CategoryLinkCloud-module-scss-module__q-Octq__category",
  "categoryLink": "CategoryLinkCloud-module-scss-module__q-Octq__categoryLink",
  "description": "CategoryLinkCloud-module-scss-module__q-Octq__description",
  "fade-in": "CategoryLinkCloud-module-scss-module__q-Octq__fade-in",
  "grid": "CategoryLinkCloud-module-scss-module__q-Octq__grid",
  "heading": "CategoryLinkCloud-module-scss-module__q-Octq__heading",
  "item": "CategoryLinkCloud-module-scss-module__q-Octq__item",
  "itemHidden": "CategoryLinkCloud-module-scss-module__q-Octq__itemHidden",
  "link": "CategoryLinkCloud-module-scss-module__q-Octq__link",
  "list": "CategoryLinkCloud-module-scss-module__q-Octq__list",
  "logo": "CategoryLinkCloud-module-scss-module__q-Octq__logo",
  "no-transform": "CategoryLinkCloud-module-scss-module__q-Octq__no-transform",
  "rotate": "CategoryLinkCloud-module-scss-module__q-Octq__rotate",
  "showMore": "CategoryLinkCloud-module-scss-module__q-Octq__showMore",
  "showMoreButton": "CategoryLinkCloud-module-scss-module__q-Octq__showMoreButton",
});
